export default __webpack_public_path__ + "static/media/4_english.362e0c58.jpg";